
import VueSelect from "vue-select";
import Plus from "vue-material-design-icons/Plus.vue";
import "vue-select/dist/vue-select.css";

let centrosCache = null;
let centrosPromise = null;

export default {
  name: "CentroCustoSelect",
  components: { VueSelect, Plus },
  props: {
    value: {
      type: [Number, String, Object],
      default: null,
    },
    label: {
      type: String,
      default: "Centro de custo",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    allowCreate: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      centros: centrosCache || [],
      termoBusca: "",
      carregando: false,
      criando: false,
    };
  },
  computed: {
    selecionado() {
      if (this.value && typeof this.value === "object") return this.value;
      return this.centros.find((centro) => String(centro.id) === String(this.value)) || null;
    },
    opcoes() {
      const busca = this.termoBusca.trim();
      const buscaNormalizada = busca.toLocaleLowerCase("pt-BR");
      const filtrados = busca
        ? this.centros.filter((centro) =>
            (centro.nome || "").toLocaleLowerCase("pt-BR").includes(buscaNormalizada)
          )
        : this.centros;
      const existeNomeExato = this.centros.some(
        (centro) => (centro.nome || "").trim().toLocaleLowerCase("pt-BR") === buscaNormalizada
      );

      return this.allowCreate && busca && !existeNomeExato
        ? [...filtrados, { id: `novo-${busca}`, nome: busca, criarNovo: true }]
        : filtrados;
    },
  },
  created() {
    this.carregar();
  },
  methods: {
    async carregar() {
      if (centrosCache) {
        this.centros = centrosCache;
        return;
      }

      this.carregando = true;
      if (!centrosPromise) {
        centrosPromise = this.$http
          .get("/financeiro/centros-custos")
          .then(({ data }) => (Array.isArray(data) ? data : data.data || []))
          .finally(() => {
            centrosPromise = null;
          });
      }

      try {
        centrosCache = await centrosPromise;
        this.centros = centrosCache;
      } finally {
        this.carregando = false;
      }
    },
    async selecionar(centro) {
      if (!centro) {
        this.$emit("input", null);
        return;
      }

      if (!centro.criarNovo) {
        this.$emit("input", centro.id);
        return;
      }

      this.criando = true;
      try {
        const { data } = await this.$http.post("/financeiro/centros-custos/create", {
          nome: centro.nome,
        });
        const novoCentro = data.data || data;
        centrosCache = [...this.centros, novoCentro].sort((a, b) =>
          a.nome.localeCompare(b.nome, "pt-BR")
        );
        this.centros = centrosCache;
        this.termoBusca = "";
        this.$emit("input", novoCentro.id);
        this.$emit("created", novoCentro);
        this.$toast.success("Centro de custo cadastrado com sucesso!");
      } finally {
        this.criando = false;
      }
    },
  },
};
